import { useQuery } from "@tanstack/react-query";
import { conversationsQueryOptions, conversationMessagesQueryOptions, usageQueryOptions } from "@/services/queries/assistantQueries";

/**
 * Assistant hooks for managing AI assistant data
 *
 * Note: These hooks accept an optional authToken parameter.
 * Components should use the useAccessToken() hook to get the token:
 *
 * @example
 * import { useAccessToken } from "@/hooks/useAccessToken";
 * import { useConversations } from "@/hooks/assistant/useAssistant";
 *
 * const MyComponent = () => {
 *   const authToken = useAccessToken();
 *   const { data, isLoading } = useConversations(authToken);
 *   // ...
 * };
 */

export const useConversations = (authToken?: string, limit: number = 50) => {
  const result = useQuery(conversationsQueryOptions(authToken, limit));
  return result;
};

export const useConversationMessages = (
  conversationId: string | undefined,
  authToken?: string,
  limit: number = 50
) => {
  return useQuery(conversationMessagesQueryOptions(conversationId, authToken, limit));
};

export const useAssistantUsage = (authToken?: string) => {
  return useQuery(usageQueryOptions(authToken));
};


